import React, { useState, useEffect, useRef } from "react";
import { useForm, Controller } from "react-hook-form";
import TableWrapper from "../../../core/BaseComponents/TableWrapper/TableWrapper";
import dayjs from "dayjs";
import { Tooltip, Autocomplete, TextField, CircularProgress } from "@mui/material";
import { MdModeEditOutline } from "react-icons/md";
import { callAPI } from "../../../../axios";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../../core/BaseComponents/Modal";
import deleteImg from '../../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";
// import ConfigrationActions from "./ConfigrationActions";
import Custom_Paingation from "../../../core/BaseComponents/Custom_Paingation";
import { ScrollToTop, getChainIdLS, isValidRole } from "../../../../utils/utils";
import { useSelector } from "react-redux";

function PublishUnPublishList(props) {
  const {parentId} = props
  const [publishUnPublishList, setPublishUnPublishList] = useState([]);
  const [confirmDeletePublishUnPublish, setConfirmDeletePublishUnPublish] = useState("");
  const [confirmValidate, setConfirmValidate] = useState(false);
  const [deletePublishUnPublishPopUp, setDeletePublishUnPublishPopUp] = useState(false);
  const [publishUnPublishPopUp, setPublishUnPublishPopUp] = useState(false);
  const [editPublishUnPublish, setEditPublishUnPublish] = useState(false);
  const [editPublishUnPublishUpdate, setEditPublishUnPublishUpdate] = useState(false);
  const [createPublishUnPublishSuccessMsg, setCreatePublishUnPublishSuccessMsg] = useState('');
  const [publishUnPublishSid, setPublishUnPublishSid] = useState("");
  // const [hotelName, setHotelName] = useState('');
  const [flag, setFlag] = useState(false);
  const [apiWelcomeMessage, setApiWelcomeMessage] = useState("")
  const [loader, setLoader] = useState(false);
  // const recordsPerPage = 10;
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    control,
    watch,
    setValue,
    clearErrors
  } = useForm({
    mode: 'onChange'
  });
  const { chainId } = useSelector((state) => state.chainIdReducer);

  let validPermissionClassName = isValidRole("WELCOME_MESSAGES_MODIFY")
    ? ""
    : "btn-disable-permission";

  // const [selectedPage, setSelectedPage] = useState(1);
  // const [totalPageCount, setTotalPageCount] = useState(1);
  // const [paginationError, setPaginationError] = useState("")
  // const [inputPageValue, setInputPageValue] = useState(1)

  const onSubmit = (data) => {

    let method = "POST";
    let url = `/scheduled-welcome-message?parentId=${parentId}&welcomeMsg=${data?.welcomeMessage}`;

    if (editPublishUnPublishUpdate) {
      method = "PUT"
      url = `/scheduled-welcome-message?id=${publishUnPublishSid?.id}&parentId=${parentId}&welcomeMsg=${data?.welcomeMessage}`
    }
    setLoader(true);
    callAPI(url, method, {}, { chainId: getChainIdLS() })
      .then(function (response) {
        reset({welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`});
        // getAvailableRooms()
        setCreatePublishUnPublishSuccessMsg(response?.message);
        publishUnPublishListApi();
        cancelPublishUnPublishHandler()
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  };

  const isPublishUnPublishDeletedRef = useRef({
    isPublishUnPublishDeletedModalData: null,
    userConformationModalData: null,
  });

  const isPublishedUnPublishedRef = useRef({
    isPublishUnPublishModalData: null,
  });


  const publishUnPublishPopUpHandler = (row) => {
    setPublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishModalData: {
        message: `Do you really want to ${row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}?`,
        row
      }
    };
    isPublishedUnPublishedRef.current = newModalRefData;
  }

  const deletePublishUnPublishPopUpHandler = (row) => {
    setDeletePublishUnPublishPopUp(true);
    const newModalRefData = {
      isPublishUnPublishDeletedModalData: {
        row
      },
      userConformationModalData: null,
    };
    isPublishUnPublishDeletedRef.current = newModalRefData;
  }

  const deletePublishUnPublishHandler = () => {
    setConfirmValidate(true);
    if (confirmDeletePublishUnPublish === "") {
      return
    }

    if (confirmDeletePublishUnPublish === `Delete ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg} Welcome Message`) {
      setConfirmValidate(false)
      const { row } = isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData;
      setLoader(true);
      callAPI(`/scheduled-welcome-message?id=${row?.id}`, "DELETE")
        .then((response) => {
          let successMessage = response.message
          const newModalRefData = {
            isPublishUnPublishDeletedModalData: null,
            userConformationModalData: {
              successMessage
            },
          };
          isPublishUnPublishDeletedRef.current = newModalRefData;
          publishUnPublishListApi();
          // getAvailableRooms();
          setLoader(false);
        })
        .catch((error) => {
          console.warn(error);
          setLoader(false);
        });
    }
    reset({
      welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
    });
  }

  const renderActionIcon = (row) => {
    return (
      isValidRole("HOTEL_CHANNELS_MODIFY") ? <>
            <Tooltip title="Edit" arrow>
              <span>
                <MdModeEditOutline
                  className="edit-icon-enable"
                  onClick={() => { setPublishUnPublishSid(row); getPublishUnPublishListSidHandler(row); setEditPublishUnPublish(true) }}
                />
              </span>
            </Tooltip>
            <Tooltip title="Delete" arrow>
              <DeleteIcon
                className="delete-icon-enable"
                onClick={() => {
                  deletePublishUnPublishPopUpHandler(row);
                }}
              />
            </Tooltip>
      </> :
        <>
          <Tooltip title="Don't have permission to edit">
            <span>
              <MdModeEditOutline className="edit-icon-disable" arrow />
            </span>
          </Tooltip>
          <Tooltip title="Don't have permission to delete">
            <DeleteIcon className="delete-icon-disable" arrow />
          </Tooltip>
          <Tooltip title="Don't have permission to delete" className="cursor-pointer" arrow>
            <span>
              <button
                type="button"
                className={`ms-3 ${row?.isPublished.toLowerCase() !== 'published' ? 'published' : 'un-published'} ${validPermissionClassName}`}
              // onClick={() => publishUnPublishPopUpHandler(row)}
              >
                {row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out'}
              </button>
            </span>
          </Tooltip>
        </>
    );
  };

  const columns = [
    { field: "createdOn", headerName: "Created On", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.createdOn).format("DD MMM YYYY | HH:mm")}</p> },
    // { field: "roomNo", headerName: "Room No", flex: 1 },
    // { field: "cdsn", headerName: "CDSN", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{row?.cdsn.map((item, index) => <span>{index ? ', ' : ''}{item}</span>)}</p> },
    // { field: "checkinDateTime", headerName: "Check-in date", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.checkinDateTime).format("DD-MM-YYYY")}</p> },
    // { field: "checkoutDateTime", headerName: "Check-out date", flex: 1, row: true, renderCell: (row) => <p className="mb-0">{dayjs(row.checkoutDateTime).format("DD-MM-YYYY")}</p> },
    // { field: "guestName", headerName: "Guest Name", flex: 1 },
    { field: "welcomeMsg", headerName: "Welcome Message", flex: 1, row: true, renderCell: (row) => <Tooltip title={row?.welcomeMsg}><p className={`mb-0 ${row?.welcomeMsg.length > 10 ? 'overflow-ellipsis' : ''}`}>{row?.welcomeMsg}</p></Tooltip> },
    {
      field: "actionCell",
      row: true,
      headerName: "Actions",
      flex: 0.5,
      renderCell: renderActionIcon,
      sortDirection: false,
      disableSortIcon: true,
    },
  ];

  const publishUnPublishListApi = () => {
    setLoader(true);
    const apiPath = `/scheduled-welcome-message/all?parentId=${parentId}`;
    callAPI(apiPath, "GET", {}, { chainId: getChainIdLS() })
      .then((response) => {
        setPublishUnPublishList(response)
        // setTotalPageCount(response?.totalPages ? response?.totalPages : 1)
        // setPaginationError("");
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setLoader(false);
      });
  };

  useEffect(() => {
    publishUnPublishListApi();
  }, [chainId]);

  useEffect(() => {
    cancelPublishUnPublishHandler();
  }, [chainId]);

  const popupCloseHandler = () => {
    setDeletePublishUnPublishPopUp(false);
    setPublishUnPublishPopUp(false);
  };

  const getPublishUnPublishListSidHandler = (row) => {
    setLoader(true);
    callAPI(`/scheduled-welcome-message?id=${row?.id}`, "GET", {}, { chainId: getChainIdLS() })
      .then(function (response) {
        const payload = {
          welcomeMessage: response?.welcomeMsg
        };
        setApiWelcomeMessage(response?.welcomeMsg)
        reset(payload);
        setEditPublishUnPublishUpdate(true);
        setLoader(false);
      })
      .catch(function (error) {
        console.warn(error.response?.data?.errorMessage);
        setLoader(false);
      });
  }

  const resetLayoutHandler = () => {
    reset({
      welcomeMessage: `Dear Guest, Welcome to ${chainId?.navSelectedhotelName?.at(0)?.name}`
    });
  }

  const cancelPublishUnPublishHandler = () => {
    resetLayoutHandler()
    setEditPublishUnPublishUpdate(false);
    setPublishUnPublishSid('');
    setEditPublishUnPublish(false);
  }

  const publishUnPublishHandler = () => {
    setLoader(true);
    const apiPath = `/publish-unpublish-message?isPublish=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.isPublished.toLowerCase() !== 'published'}&Id=${isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.id}`;
    callAPI(apiPath, "POST", {}, { chainId: getChainIdLS() })
      .then((res) => {
        setFlag(!flag)
        let successMessage = res.message
        const newModalRefData = {
          isPublishUnPublishModalData: {
            message: successMessage
          }
        };
        isPublishedUnPublishedRef.current = newModalRefData;
        publishUnPublishListApi();
        setLoader(false);
      })
      .catch((err) => {
        console.warn(err.message);
        setPublishUnPublishPopUp(false);
        setLoader(false);
      });
  }

  return (
    <div className='row config-hotel mt-2'>
      <div className='col-12 left-column px-0'>
         {loader && <div style={{zIndex: "99999"}} className="circular-progress"><CircularProgress /></div>}
        <form autoComplete="off" className={`hotel-list-form ${editPublishUnPublish ?"":publishUnPublishList?.length ?"page-mask":""} `}>
        {publishUnPublishList?.length>0 && !editPublishUnPublish && <div className='mask-content default-config'>Only one configuration can be created at a time. <br/> Please update existing one if required.</div> }
          <div className="row">
            <div className="row pe-0">

              <div className="d-flex">
                <div className="col-8 mb-3">
                  <Controller
                    name="welcomeMessage"
                    control={control}
                    // defaultValue=""
                    rules={{ required: "Welcome Message is required" }}
                    render={({ field }) => (
                      <textarea
                        {...field}
                        id="welcomeMessage"
                        style={{height: '50px' }}
                        maxLength={60}
                        placeholder="Write a welcome message here..."
                      />
                    )}
                  />
                  {errors.welcomeMessage && <small className="required">{errors.welcomeMessage.message}</small>}
                </div>
                {/* <div>
                  <button type="button" className="clear-btn ms-3" 
                  onClick={resetWelcomeMessageHandler}>Reset Message</button>
                </div> */}
              
              </div>
              
            </div>
            <div className="col-12 text-end">
              {/* <div> */}
              <button type="button" className="clear-btn me-2" onClick={cancelPublishUnPublishHandler}>{editPublishUnPublishUpdate ? "Cancel" : "Clear All"}</button>
              {editPublishUnPublishUpdate && <>
                <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
              </>}
              {!editPublishUnPublishUpdate && <button type="button" disabled={isSubmitting} className={`disable-btn me-2 ${validPermissionClassName}`} onClick={handleSubmit(onSubmit)}>Save</button>}
              <button type="button" disabled={isSubmitting} className={`create-btn ${validPermissionClassName} `} onClick={handleSubmit(onSubmit)}>Update</button>
              {/* </div> */}
            </div>
          </div>
        </form>
        <div className="hotel-list">
          <p><b>Welcome Messages List</b></p>
          <TableWrapper
            data={publishUnPublishList}
            columns={columns}
            module="publish-unpublish"
            noPagination={true}
          />
          {/* <Custom_Paingation
            selectedPage={selectedPage}
            totalPageCount={totalPageCount}
            paginationError={paginationError}
            inputPageValue={inputPageValue}
            setSelectedPage={setSelectedPage}
            setPaginationError={setPaginationError}
            setInputPageValue={setInputPageValue}
            onPageChange={onPageChange}
          /> */}
        </div>
      </div>
      {/* <ConfigrationActions /> */}
      <BasicModal
        popupOpen={deletePublishUnPublishPopUp}
        bodyMessage={<>
          <img src={deleteImg} alt="approve" className="w-40px" />
          <div className="delete-hotel mb-3">{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            <div className="confirm-delete-hotel">
              <p>Do you really want to Delete Welcome Message "<b>{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg}</b>" ?</p>
              <p className="warning"><IoMdWarning /> Warning</p>
              <p>"{isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg}" Welcome Message will be permanently deleted <br />
                Deleting the specified Room Welcome Message can't be undone.
              </p>
              <p className="mt-3">To confirm deletion, type "Delete {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg} Welcome Message"</p>
              <div className="form-group-hotel mt-3">
                <div className="floating-label">
                  <input
                    id="deleteHotel"
                    // maxLength={40}
                    placeholder=''
                    onChange={(e) => setConfirmDeletePublishUnPublish(e.target.value)}
                  />
                  <label htmlFor="address">Delete Welcome Message</label>
                </div>
                {(confirmDeletePublishUnPublish === "" && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg} Welcome Message</small></p>
                ) : (confirmDeletePublishUnPublish !== `Delete ${isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg} Welcome Message` && confirmValidate) ? (
                  <p className="text-start"><small className="required">Please Enter Delete {isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData.row.welcomeMsg} Welcome Message</small></p>
                ) : ""
                }
              </div>
            </div> :
            isPublishUnPublishDeletedRef.current?.userConformationModalData?.successMessage}</div>
        </>
        }
        footer={
          isPublishUnPublishDeletedRef.current?.isPublishUnPublishDeletedModalData ?
            {
              primaryButton: {
                buttonName: "Cancel",
                action: popupCloseHandler
              }
              ,
              secondaryButton: {
                buttonName: "Delete",
                action: deletePublishUnPublishHandler
              }
            } : {
              secondaryButton: {
                buttonName: "OK",
                action: popupCloseHandler
              }
            }
        }
      />

      <BasicModal
        popupOpen={createPublishUnPublishSuccessMsg !== ""}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<p className="mt-2">{createPublishUnPublishSuccessMsg}</p>}
        // customcss={true}
        footer={
          {
            secondaryButton: {
              buttonName: "OK",
              action: () => { setCreatePublishUnPublishSuccessMsg(''); setEditPublishUnPublishUpdate(false); },
              buttonPrimaryCustomCss: 'cancel-btn_new'
            }
          }
        }
      />
      <BasicModal
        popupOpen={publishUnPublishPopUp}
        logo={"/Images/approve-qc.png"}
        bodyMessage={<>
          {isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData && <p className="mt-2">{isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message}</p>}
        </>
        }
        footer={
          isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Check-In?" ||
            isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.message === "Do you really want to Check-Out?" ? {
            primaryButton: {
              buttonName: "Cancel",
              action: popupCloseHandler
            },
            secondaryButton: {
              buttonName: isPublishedUnPublishedRef?.current?.isPublishUnPublishModalData?.row?.isPublished.toLowerCase() !== 'published' ? 'Check-In' : 'Check-Out',
              action: publishUnPublishHandler
            }
          } : {
            secondaryButton: {
              buttonName: "OK",
              action: popupCloseHandler
            }
          }
        }
      />
    </div>
  )
}

export default PublishUnPublishList;